import request from 'Request'

const RemarksService = {
  async get({ encounterId, type }) {
    return request.post('/remarks/list', { encounterId, type })
  }
}

export default RemarksService
